import { Box } from '@mui/material';
import React from 'react';

import { useScope } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import SiteGroupGrid from './components/SiteGroupGrid';

export function SiteGroupGridViewPage({
  match: { params },
  defaultStatus = 'active',
  persistScope = 'siteGroupGrid',
  ...props
}) {
  const { customer } = useScope();
  const pageTitle = customer?.name ?? 'Unknown';
  return (
    <AppNav flex notFullHeight page="customer_plants" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={pageTitle} />
        <SiteGroupGrid customer={customer} defaultStatus={defaultStatus} persistScope={persistScope} />
      </Box>
    </AppNav>
  );
}

export default SiteGroupGridViewPage;
